export default {
  "date": {
    "today": "aujourd'hui",
    "tomorrow": "demain"
  }
};
